import React, { Component } from 'react';
import { Form, Field } from 'react-final-form';
import * as actionCreators from '../store/actions';
import { connect } from 'react-redux';

class LoginInnerForm extends Component {
  render() {
    return (
      <form onSubmit={this.props.handleSubmit}>
        {(!this.props.submitting && !this.props.pristine && this.props.login.error) ?
        <div className="alert alert-danger">
          {this.props.login.error}
        </div> :
         ""}
        <div className="form-group">
          <Field className="form-control" name="email" component="input" placeholder="Username"/>
        </div>
        <div className="form-group">
          <Field className="form-control" type="password" name="password" component="input" placeholder="Password"/>
        </div>
        <div className="buttons">
          <button
            type="submit" disabled={this.props.submitting || this.props.pristine}
            className="btn btn-primary">
            Submit
          </button>
        </div>
      </form>
    );
  }
}

const loginInnerSelector = (state) => ({login: state.session.login});
const LoginInnerComponent = connect(loginInnerSelector)(LoginInnerForm);

class LoginForm extends Component {
  constructor() {
    super();
    this.submit = this.submit.bind(this);
  }
  submit(form) {
    this.props.createSession(form);
  }
  render() {
    return (
      <Form onSubmit={this.submit} component={LoginInnerComponent} />
    );
  }
}

const loginSelector = (state) => ({});
export const LoginComponent = connect(loginSelector, actionCreators)(LoginForm);



// WEBPACK FOOTER //
// ./src/components/login.js